import { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Loading from './app/components/common/loading/Loading';
import { useAuth } from './app/hooks/useAuth';
import { useTypedSelector } from './app/hooks/useTypedSelector';
import { getCurrentUser } from './app/store/authSlice';
import { siteMap } from './siteMap';
import { useAccess } from './app/hooks/useAccess';

// Clean up legacy tokens from localStorage (migrated to httpOnly cookies)
const clearLegacyTokens = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
};

function App() {
  const { setMyself } = useAuth();
  const user = useTypedSelector(getCurrentUser());
  const { getPageAccess } = useAccess();

  useEffect(() => {
    clearLegacyTokens();
    setMyself();
  }, []);

  return user === undefined
    ? <Loading isfullScreen />
    : <RouterProvider
        router={createBrowserRouter(siteMap(getPageAccess))}
        fallbackElement={<> </>}
    />
}

export default App;
